<template>
  <div class="table-box">
    <el-table ref="tableRef" v-loading="isLoading" :class-name="Module" :data="Datas"
              :highlight-current-row="AllowSelectRow" :indent="33"
              :load="TreeLoadDataFun" :row-class-name="RowClassName" :row-key="KeyField"
              :stripe="true" :tree-props="{ children: 'Children', hasChildren: 'HasChildren' }" lazy
              @filter-change="FilterChanged" @sort-change="SortChanged" @cell-click="CellClick"
              @selection-change="selectionChanged">
      <el-table-column v-if="ShowSelectColumn && !CustomSelected" :selectable="SelectableFun" class-name="action_column"
                       fixed="left" type="selection" width="35"/>
      <!-- 自定义选择列 -->
      <el-table-column v-if="ShowSelectColumn && CustomSelected" :selectable="SelectableFun" class-name="action_column"
                       fixed="left" width="35">
        <template #header>
          <el-checkbox v-model="isSelectedALL" @change="SelectedAllChanged"/>
        </template>
        <template #default="scope">
          <el-checkbox v-model="scope.row[props.CustomSelectedField]" @change="SelectedChanged(scope.row, $event)"/>
        </template>
      </el-table-column>
      <template v-for="(column, index) in (Columns as any[])" :key="column.Code">
        <el-table-column
            v-if="IsNeedHeaderFilter ? column.Display !== false && column.IsShow : column.Display !== false"
            :align="column.Align" :class-name="column.Code" :column-key="column.Code"
            :filter-method="column.FilterMethod" :filter-multiple="column.FilterMultiple === true"
            :filtered-value="column.FilteredValue ? JSON.parse(column.FilteredValue) : column.FilteredValue"
            :filters="column.Filters" :fixed="column.Fixed" :header-align="column.Align"
            :label="column.Header" :label-class-name="column.HeaderSlot ? 'HeaderSlot' : ''"
            :min-width="column.MinWidth" :prop="column.Code"
            :show-overflow-tooltip="column.Code !== action_column" :sortable="column.Sortable ? 'custom' : false"
            :type="column.type" :width="column.Width">
          <template v-if="column.HeaderSlot" #header>
            <slot :column="column" :name="`${column.Code}Header`"/>
          </template>
          <template #default="scope">
            <template v-if="column.type === 'index'">
              {{ scope.$index + 1 }}
            </template>
            <template v-if="!column.Slot && !column.IsEstate && column.type !== 'index'">
              {{ scope.row[column.Code] }}
            </template>
            <el-tag v-if="column.IsEstate"
                    :type="scope.row[column.Code] === Framework.Estate.Normal ? 'success' : 'danger'">
              {{ ConvertEstate(scope.row[column.Code]) }}
            </el-tag>
            <slot v-if="column.Slot && !column.IsEstate" :index="index" :name="column.Code" :row="scope.row"
                  :value="scope.row[column.Code]"/>
            <el-button-group v-if="column.Slot && column.ShowBaseActionBtn">
              <!-- 查看 -->
              <power :Action="Framework.Operating.View" :Module="props.Module">
                <template #default="scopePower">
                  <el-tooltip v-if="column.NeedViewBtn"
                              :content="  scope.row['ViewDisabled'] && scope.row['DisabledTip'] ? scope.row['DisabledTip']   : `无查看权限`  "
                              :disabled="!scope.row['ViewDisabled'] && scopePower.hasPower" placement="top">
                    <el-button :disabled="scope.row['ViewDisabled'] || !scopePower.hasPower" class="btn-op" text
                               type="primary" @click="ViewHandle(scope.row)">
                      查看
                    </el-button>
                  </el-tooltip>
                </template>
              </power>
              <!-- 编辑 -->
              <power :Action="Framework.Operating.Modify" :Module="props.Module">
                <template #default="scopePower">
                  <el-tooltip
                      :content=" scope.row['EditDisabled'] && scope.row['DisabledTip']  ? scope.row['DisabledTip']   : `无编辑权限` "
                      :disabled="!scope.row['EditDisabled'] && scopePower.hasPower" placement="top">
                    <el-button :disabled="scope.row['EditDisabled'] || !scopePower.hasPower" class="btn-op" text
                               type="primary" @click="EditHandle(scope.row, scope.$index)">
                      编辑
                    </el-button>
                  </el-tooltip>
                </template>
              </power>
              <slot :row="scope.row" name="ExAction"/>
              <power :Action="Framework.Operating.Modify" :Module="props.Module">
                <template #default="scopePower">
                  <!-- 停用 -->
                  <el-tooltip v-if="!column.UnNeedEstateBtn && scope.row[EstateField] === Framework.Estate.Normal"
                              :content=" scope.row['EstateDisabled'] && scope.row['DisabledTip']    ? scope.row['DisabledTip']   : `无编辑权限`"
                              :disabled="!scope.row['EditDisabled'] && scopePower.hasPower" placement="top">
                    <el-button :disabled="scope.row['EstateDisabled'] || !scopePower.hasPower" class="btn-op" text
                               type="warning" @click="UpdateEstate(scope.row, Framework.Estate.Stop)">
                      停用
                    </el-button>
                  </el-tooltip>
                  <!-- 恢复 -->
                  <el-tooltip v-if="!column.UnNeedEstateBtn && scope.row[EstateField] !== Framework.Estate.Normal"
                              :content=" scope.row['EstateDisabled'] && scope.row['DisabledTip'] ? scope.row['DisabledTip'] : `无编辑权限`"
                              :disabled="!scope.row['EditDisabled'] && scopePower.hasPower" placement="top">
                    <el-button :disabled="scope.row['EstateDisabled'] || !scopePower.hasPower" class="btn-op" text
                               type="success" @click="UpdateEstate(scope.row, Framework.Estate.Normal)">
                      启用
                    </el-button>
                  </el-tooltip>
                </template>
              </power>
              <!-- 删除 -->
              <power :Action="Framework.Operating.Del" :Module="props.Module">
                <template #default="scopePower">
                  <el-popconfirm :disbled="scope.row['DelDisabled'] || !scopePower.hasPower" cancel-button-text="取消"
                                 confirm-button-text="确认删除" icon-color="red"
                                 title="此操作将永久删除该数据, 是否继续?" width="300px"
                                 @confirm="DeleteHandle(scope.row)">
                    <template #reference>
                      <label>
                        <el-tooltip
                            :content="scope.row['DelDisabled'] && scope.row['DisabledTip'] ? scope.row['DisabledTip'] : `无删除权限` "
                            :disabled="!scope.row['DelDisabled'] && scopePower.hasPower" placement="top">
                          <el-button :disabled="scope.row['DelDisabled'] || !scopePower.hasPower" class="btn-op" text
                                     type="danger">
                            删除
                          </el-button>
                        </el-tooltip>
                      </label>
                    </template>
                  </el-popconfirm>
                </template>
              </power>
            </el-button-group>
            <el-dropdown v-if="column.Slot && column.needMoreOp" class="more-ops-container" trigger="click">
                    <span class="text-wrapper">
                      <label>更多操作</label>
                      <i class="el-icon-caret-bottom"/>
                    </span>
              <template #dropdown>
                <el-dropdown-menu>
                  <slot :row="scope.row" name="dropdown"/>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </template>
        </el-table-column>
      </template>
      <template #empty>
        <el-empty v-if="!isLoading" :image-size="100" description="暂无数据"/>
        <span v-else>数据加载中</span>
      </template>
    </el-table>
  </div>
  <el-footer v-if="NeedPagination || ShowSelectColumn">
    <div>
      <el-button-group v-if="ShowSelectColumn" class="oper">
        <power :Action="Framework.Operating.Modify" :Module="props.Module">
          <template #default="scopePower">
            <!-- 停用 -->
            <el-tooltip :disabled="scopePower.hasPower" content="无编辑权限" placement="top">
              <el-button v-if="!UnNeedEstateBtn" :disabled="selectedList.length <= 0 || !scopePower.hasPower"
                         @click="UpdateEstate(null, Framework.Estate.Stop)">
                <svg-icon icon-class="Stop"/>
                批量停用
              </el-button>
            </el-tooltip>
            <!-- 恢复 -->
            <el-tooltip :disabled="scopePower.hasPower" content="无编辑权限" placement="top">
              <el-button v-if="!UnNeedEstateBtn" :disabled="selectedList.length <= 0 || !scopePower.hasPower"
                         @click="UpdateEstate(null, Framework.Estate.Normal)">
                <svg-icon icon-class="Enable"/>
                批量启用
              </el-button>
            </el-tooltip>
          </template>
        </power>
        <!-- 删除 -->
        <power :Action="Framework.Operating.Del" :Module="props.Module">
          <template #default="scopePower">
            <el-popconfirm v-if="!UnNeedDelBtn" :disabled="selectedList.length <= 0 || !scopePower.hasPower"
                           cancel-button-text="取消" confirm-button-text="确认删除" icon-color="red"
                           title="此操作将永久删除这些数据, 是否继续?" width="300px" @confirm="DeleteHandle(null)">
              <template #reference>
                <label>
                  <el-tooltip :disabled="scopePower.hasPower" content="无删除权限" placement="top">
                    <el-button :disabled="selectedList.length <= 0 || !scopePower.hasPower">
                      <svg-icon icon-class="Delete"/>
                      批量删除
                    </el-button>
                  </el-tooltip>
                </label>
              </template>
            </el-popconfirm>
          </template>
        </power>
        <slot name="Footer"/>
      </el-button-group>
      <el-button-group v-else>
        <slot name="Footer"/>
      </el-button-group>
    </div>
    <div class="foot-right">
      <el-pagination v-if="NeedPagination" v-model:current-page="pIndex" v-model:page-size="pSize" :pager-count="5"
                     :total="TotalCounts" layout="total,  prev, pager, next,  sizes,"
                     @size-change="PageSizeChanged" @current-change="PageChanged"/>
    </div>
  </el-footer>
</template>

<script lang="ts" setup>
import {computed, ref} from "vue";
import {Framework} from "./proto/proto";
import power from "./power.vue"
import {ConvertEstate} from "./axios"

const props = defineProps({
  /** 模块 */
  Module: String,
  /** 主键字段 */
  KeyField: {type: String, default: "ID"},
  /** 名称字段 */
  NameField: {type: String, default: "Name"},
  /** 父编号字段字段 */
  ParentIDField: {type: String, default: "ParentID"},
  /** 状态字段 */
  EstateField: {type: String, default: "Estate"},
  /** 排序字段 */
  SortField: {type: String},
  /** 排序方向 */
  SortDir: {type: Number},
  /** 搜索值 */
  SearchValue: String,
  /** 显示视图列 */
  ShowViewBar: Boolean,
  /** 自定义视图列 */
  MyViewBar: {type: Boolean, default: false},
  /** 显示视图标题 */
  ViewIsTitle: {type: Boolean, default: true},
  /** 视图列标题 */
  ViewBarTitle: String,
  /** 创建视图描述 */
  CreateViewDesc: String,
  /** 显示创建视图按钮 */
  ShowCreateView: {type: Boolean, default: true},
  /** 显示创建按钮 */
  ShowCreateButton: {type: Boolean, default: true},
  /** 创建按钮文字 */
  ButtonText: {type: String, default: ""},
  /** 顶部菜单 */
  TopMenu: {type: Array, default: () => []},
  /** 是否需要查询 */
  NeedSearch: {type: Boolean, default: true},
  /** 是否需要分页 */
  NeedPagination: {type: Boolean, default: true},
  /** 数据 */
  Datas: Array,
  /** 显示选择列 */
  ShowSelectColumn: Boolean,
  CustomSelected: Boolean,
  CustomSelectedField: {type: String, default: ""},
  /** 底部批量操作区域不需要状态操作按钮 */
  UnNeedEstateBtn: Boolean,
  /** 底部批量操作区域不需要删除操作按钮 */
  UnNeedDelBtn: Boolean,
  /** 列 */
  Columns: {type: Array, default: () => []},
  /** 复选框是否可以选中 */
  SelectableFun: Function,
  /** 树加载回调 */
  TreeLoadDataFun: Function,
  /** 树的节点过滤 */
  TreeFilterNode: Function,
  /** 行状态，用于区分成功之类的 由各自业务区分 */
  RowClassName: Function,
  /** 当前第几页 */
  PageIndex: {type: Number, default: 1},
  /** 分页大小 */
  PageSize: {type: Number, default: 100},
  /** 总行数 */
  TotalCounts: Number,
  /** 是否有过滤项 */
  HasFilters: Boolean,
  /** 过滤条件数 */
  FilterCount: Number,
  /** 是否允许选中行 */
  AllowSelectRow: Boolean,
  /** 本地过滤 */
  LocalFilter: {type: Boolean, default: false},
  /** 删除 */
  DeleteFun: Function,
  /** 更新状态 */
  UpdateEstateFun: Function,
  /** 选中数据 */
  Selections: {type: Array, default: () => []},
  isLoading: {type: Boolean, default: false},
  // 是否需要表头筛选
  IsNeedHeaderFilter: {type: Boolean, default: false},
  // 动作列Code
  action_column: {type: String, default: "oprate"},
});
const tableRef = ref();
const selectedList = ref<any[]>([]);
const pIndex = computed({
  get: () => props.PageIndex,
  set: (val) => emit("update:PageIndex", val)
});
const pSize = computed({
  get: () => props.PageSize,
  set: (val) => emit("update:PageSize", val)
});
// 编辑、删除
const hasEditPower = computed(() => true);
const hasDelPower = computed(() => true);
const isSelectedALL = computed(() => {
  return props.Datas?.every((val: any) => val.IsSelected === true);
});
/** 声明事件 */
const emit = defineEmits([
  "LoadData",
  "update:SearchValue",
  "update:PageIndex",
  "update:PageSize",
  "update:SortField",
  "update:SortDir",
  "update:Selections",
  "FilterChanged",
  "EditRowHandle",
  "ViewRowHandle",
  "SelectionChanged",
  "CellClick",
  "TreeNodeRefresh",
]);

/** 当表格的筛选条件发生变化的时候会触发该事件，参数的值是一个对象，对象的 key 是 column 的 columnKey，对应的 value 为用户选择的筛选条件的数组。 */
const FilterChanged = async (filters: any) => {
  try {
    const key = Object.keys(filters)[0];
    // 动态同步父组件的筛选值。
    const column = (props.Columns as any).find((c: any) => c.Code === key);

    let value = filters[key][0];

    if (column && column.FilterMultiple) {
      value = "";
      await filters[key].forEach((f: any, i: any) => {
        value += f;
        if (i < filters[key].length - 1) {
          value += ",";
        }
      });
    }

    emit("update:PageIndex", 1);
    emit(`FilterChanged`, key, value);
    if (!props.LocalFilter) {
      emit("LoadData");
      clearSelection();
    }
  } catch {
    console.debug("FilterChanged", filters);
  }
};
/** 当表格的排序条件发生变化的时候会触发该事件 */
const SortChanged = (orderInfo: any) => {
  if (orderInfo) {
    const column = (props.Columns as any).find((c: any) => c.Code === orderInfo.prop);

    if (column) emit("update:SortField", column.SortField ? column.SortField : orderInfo.prop);
    emit("update:SortDir", orderInfo.order === "descending" ? 1 : 0);
    emit("update:PageIndex", 1);
    emit("LoadData");
    clearSelection();
  }
};
/** 多选响应方法 */
const selectionChanged = (val: any[]) => {
  selectedList.value = val.map((item) => item[props.KeyField as any]);
  emit("update:Selections", selectedList.value);
};

/** 全选操作 */
const SelectedAllChanged = () => {
  const isChoose = isSelectedALL.value;
  props.Datas?.forEach((element: any) => {
    element[props.CustomSelectedField] = !isChoose;
  });
};
const SelectedChanged = (row: any, value: boolean) => {
  let hasSelectedCount = 0;
  let hasUnSelectedCount = 0;
  props.Datas?.forEach((element: any) => {
    if (element[props.CustomSelectedField]) {
      hasSelectedCount++;
    } else {
      hasUnSelectedCount++;
    }
  });

  // if (hasUnSelectedCount > 0) {
  //   isSelectedALL.value = false;
  // } else if (hasSelectedCount > 0) {
  //   isSelectedALL.value = true;
  // }
};

/** 分页大小改变时会触发 */
const PageSizeChanged = (val: number) => {
  emit("update:PageIndex", 1);
  emit("update:PageSize", val);
  emit("LoadData");
  clearSelection();
};
/** 分页大小改变时会触发 */
const PageChanged = (val: number) => {
  emit("update:PageIndex", val);
  emit("update:PageSize", props.PageSize);
  emit("LoadData");
  clearSelection();
};
/** 当某个单元格被点击时会触发该事件 */
const CellClick = (row: any, column: any, cell: any, event: any) => {
  emit("CellClick", row, column, cell, event);
};
// 清除表格选择
const clearSelection = () => {
  if (tableRef.value && props.ShowSelectColumn) {
    tableRef.value.clearSelection();
  }
};

/** 查看按钮 */
const ViewHandle = (row: object) => {
  emit("ViewRowHandle", row);
};
/** 编辑按钮 */
const EditHandle = (row: object, index: number) => {
  emit("EditRowHandle", row, index);
};
/** 删除行 */
const DeleteHandle = async (row: any) => {
  const ids = [] as any;
  const titles = [] as any;
  if (row) {
    ids.push(row[props.KeyField as any]);
    if (row[props.NameField]) titles.push(row[props.NameField as any]);
  } else {
    tableRef.value.getSelectionRows().forEach((row1: any) => {
      ids.push(row1[props.KeyField as any]);
      if (row1[props.NameField]) titles.push(row1[props.NameField as any]);
    });
  }
  // console.log(row, ids, titles, "row");

  if (props.DeleteFun) {
    props.DeleteFun(ids, titles, row);
  }
  clearSelection();
};

/** 更新状态 */
const UpdateEstate = async (row: any, estate: number) => {
  const ids = [] as any;
  const titles = [] as any;
  if (row) {
    ids.push(row[props.KeyField as any]);
    if (row[props.NameField]) titles.push(row[props.NameField as any]);
  } else {
    tableRef.value.getSelectionRows().forEach((row1: any) => {
      ids.push(row1[props.KeyField as any]);
      if (row1[props.NameField]) titles.push(row1[props.NameField as any]);
    });
  }

  if (props.UpdateEstateFun) {
    props.UpdateEstateFun(ids, estate, titles, row);
  }
  clearSelection();
};

/** 更新树节点数据 */
const UpdateTreeData = (id: string, newData: any[]) => {
  if (id && !Array.isArray(id)) {
    tableRef.value.store.states.lazyTreeNodeMap.value[id] = newData;
  }
};

// 表格内容跳转指定位置
const tabScrollbarRef = ref();
const scrollTo = (top: any) => {
  tabScrollbarRef.value.scrollTo(0, top);
};
/** 清空表格排序 */
const ClearSort = () => {
  tableRef.value.clearSort();
};

defineExpose({
  UpdateTreeData,
  scrollTo,
  ClearSort,
  clearSelection
});
</script>

<style lang="scss" scoped>

</style>